const info: any = [
    {
        type: "faq",
        title: "Where can I find views showing machine alarms etc?",
        content: "From the top menu bar, you can select Machine Analytics or Global Analytics. The Machine Data app and the Global View app both show machine data. Machine Analytics contains deep analysis of a sinlge assembly with features such as the timeline. Global Analytics gives you the opportunity to compare different assemblys and devices",
        categorys: ["Navigation"],
        group: "Navigation",
        tags: ["alarms", "triggers", "statistics", "data", "analytics", "timeline", "charts"]
    },
    {
        type: "faq",
        title: "On the customer/machine view, why are machines from MPE and D365 listed seperatley?",
        content: "All machines should be found in the D365 database however not all machines are stored in the MPE database. They are listed seperatley as machines stored in MPE have more data available and it is useful for the user to know which machines have this additional information and which do not.",
        categorys: ["Machine List"],
        group: "Customer/Machine Dashboard",
        tags: ["machine list", "assembly list", "d365", "mpe"]
    },
    {
        type: "faq",
        title: "How do i see more information and content about the machine such as machine files, spare parts, pictures etc?",
        content: "From the Home view, click on a machine. Once selected the machine text will be highlighted and the dashboard below will be updated to show information regarding the selected machine only.",
        categorys: ["Machine List"],
        group: "Customer/Machine Dashboard",
        tags: ["machine list", "assembly list", "d365", "mpe", "machine pictures", "spare parts", "machine files"]
    },
    {
        type: "faq",
        title: "How do i get it back to view the customer information on the dashboard?",
        content: "Click on the customer Name / customer Id in the Customer Information panel. You many need to scroll to the top of the screen to find the panel.Once selected the customer name text will be highlighted and the dashboard below will be updated to show information regarding the customer",
        categorys: ["Machine List"],
        group: "Customer/Machine Dashboard",
        tags: ["machine list", "customer dashboard"]
    },
    {
        type: "faq",
        title: "Why does is say 'No data found'?",
        content: "Not all customers and machines have certain data available",
        categorys: ["Machine List"],
        group: "Customer/Machine Dashboard",
        tags: ["customer data"]
    },
    {
        type: "faq",
        title: "Why can I not see certain device serial numbers in the machine list panel?",
        content: "Click on the expand/magnify icon in the top right of the panel, this will show any devices and their serial numbers that are part of an assembly",
        categorys: ["Machine List"],
        group: "Customer/Machine Dashboard",
        tags: ["devices"]
    },
    {
        type: "faq",
        title: "How can I see 'all' devices that belong to an assembly?",
        content: "On the Customer Dashboard,By clicking on a machine, the dashboard will change to show panels relevant to the machine. The Assembly Devices panel gives a full detailed list of all devices belonging to an assembly.",
        categorys: ["Machine List", "Customer Dashboard"],
        group: "Customer/Machine Dashboard",
        tags: ["assembly devices"]
    },
    {
        type: "faq",
        title: "Why can I only see archive service reports?",
        content: "As of January 2023, service reports are cretaed and viewed with the PST application.",
        categorys: ["Service Reports", "Customer Dashboard"],
        group: "Customer/Machine Dashboard",
        tags: ["archive"]
    },
    {
        type: "faq",
        title: "Why can I not see all alarm data by default? (Machine Analytics)",
        content: "In the alarm filters panel of the sidebar you can select all filters and click update, this will then show all available alarm data. Note the default end date selection is yesterday's date.",
        categorys: ["Alarm Information", "Alarm Grid Information", "Alarm Column Chart Information", "Timeline Information"],
        group: "Alarms",
        tags: ["alarms", "alarm", "filters", "data", "missing"]
    },
    {
        type: "faq",
        categorys: ["Alarm Column Chart Information"],
        group: "Alarms",
        title: "I clicked on a chart column and everyting reloaded. Now i do not see as much data. Why?",
        content: "This is by design. Clicking on an alarm text column on the chart will update the alarm filter to show only alarms with the selected alarm text. This can be reset in the Alarm filters panel of the sidebar, remove the alarm text from the drop down column and click update.",
        tags: ["alarms", "chart", "alarm", "filters"]
    },
    {
        type: "faq",
        categorys: ["Alarm Grid Information"],
        group: "Alarms",
        title: "I expanded a row to see alarm translations but there is none available, why? (Machine Analytics)",
        content: "Unfortunately not all alarms have translations available",
        tags: ["alarms", "chart", "alarm", "filters"]
    },
    {
        type: "faq",
        group: "Devices",
        categorys: ["Device Information"],
        title: "The latest data timestamp is not as recent as expected. How do i find out more why?",
        content: "The Fleet Data Monitoring app gives more information about data collection of each device and can help find any problems.",
        tags: ["device", "devices"]
    },
    {
        type: "faq",
        group: "Devices",
        categorys: ["Device Information"],
        title: "What is the difference between raw and enriched data?",
        content: "The raw data is the how it is as collected at the machine.The enriched data is the result of processing raw data and storing it with new values.The purpose of this enriched data is to filter out some of the noise.to add analysis(eg totals), and to create categorization.Becuase enriching the data takes time, enriched data from the current date is not available.The majority of this application uses enriched data.",
        tags: ["device", "devices", "enriched", "raw"]
    },

    {
        type: "faq",
        group: "Devices",
        categorys: ["Filters Panel"],
        title: "Why can I not find the Customer/Device I am searching for in Machine Analytics?",
        content: "Only customer devices with collected machine data(alarms,machine states, triggers, mdc) are listed.",
        tags: ["device", "devices", "filters"]
    },
    {
        type: "faq",
        group: "Dashboard",
        categorys: ["Dashboard"],
        title: "How do i view my saved dashboards in Machine Analytics?",
        content: "In the menu go to 'My Dashboards'. Fom there selected the saved dashbaord you wish to load. Note: Dashboards are only available from the device used when saving the dashboard",
        tags: ["dashboard", "custom"]
    },
    {
        type: "faq",
        group: "Dashboard",
        categorys: ["Dashboard"],
        title: "The widget/dashboard component is too small, how can i resize it?",
        content: "You can click on the bottom or right borders of a widget and drag the mouse to resize it. Alternatively, you click the full screen icon in the topr right corner of the widget.",
        tags: ["dashboard", "custom"]
    },
    {
        type: "faq",
        group: "Dashboard",
        categorys: ["Dashboard"],
        title: "I deleted a widget/dashboard component. How do i get it back?",
        content: "In the sidebar, find the 'Dashboard Options' panel. Click on reset to put the dashbaord back to it's default state. Alternatively from 'Dashboard Options', you can use the widget library to add a new widget.",
        tags: ["dashboard", "widget"]
    },
    {
        type: "faq",
        group: "Devices",
        categorys: ["Root Cause Information", "Machine Times Information"],
        title: "Why can I only select one device on certain views? (Machine Analytics)",
        content: "Some of the data visualizations only work by viewing one device at a time.",
        tags: ["devices", "filters", "root cause", "machine times"]
    },
    {
        type: "faq",
        group: "Root Cause",
        categorys: ["Root Cause Information"],
        title: "What do the colors on the root cause diagram represent?",
        content: "The meaning of the diagram colors can be found in the definitions tab.",
        tags: ["colors", "root cause"]
    },
    {
        type: "faq",
        group: "Root Cause",
        categorys: ["Root Cause Information"],
        title: "I clicked on a node and it changed to pink and now I do not see all the data in the root cause analysis widget?",
        content: "This is by design. Clicking on a diagram node filters the the data in Root cause analysis widget so only data from selected node is shown. To reset, simply select the 'Total triggers' node.",
        tags: ["filters", "root cause"]
    },
    {
        type: "faq",
        group: "Triggers",
        categorys: ["Trigger Grid Information", "Trigger Chart Information"],
        title: "How can I view only certain types of triggers in Machine Analytics?",
        content: "In the sidebar look for the 'Trigger Filters' panel. There you can select which trigger texts you want to view, click update and the dashboard will be updated to only show triggers of your selected types. By default it shows all. If you only want to quickly filter a data grid to search for a certain type of trigger, you can use the grid filter at the top of the column. This will filter your grid without reloading the data and without affecting other dashboard items eg charts.",
        tags: ["filters", "triggers"]
    },
    {
        type: "faq",
        group: "Triggers",
        categorys: ["Trigger Grid Information"],
        title: "When i click Show Data, no data is displayed? (Machine Analytics)",
        content: "Not all triggers contain trigger data",
        tags: ["missing data", "triggers"]
    },
    {
        type: "faq",
        group: "Triggers",
        categorys: ["Trigger Grid Information"],
        title: "When i click 'Show Alarms', nothing shows? (Machine Analytics)",
        content: "Only alarms that occur in a range of 5 second before and 5 second after the trigger timestamp are displayed.",
        tags: ["missing data", "triggers"]
    },
    {
        type: "faq",
        group: "Data Grid",
        categorys: ["Trigger Grid Information", "Alarm Grid Information", "Event Grid Information", "Data Grid Information"],
        title: "How do i sort the grid?",
        content: "Clicking on the column header will sort the grid using that column. Clicking on the header a second time will sort the data in descending order. A third click will put the grid back to it's default state.",
        tags: ["sort", "data grid"]
    },
    {
        type: "faq",
        group: "Data Grid",
        categorys: ["Trigger Grid Information", "Alarm Grid Information", "Event Grid Information", "Data Grid Information"],
        title: "How do i export the grid data?",
        content: "Clicking on the 3 dot icon in the top left corner of the grid will show the 'Export to Excel' button.",
        tags: ["export", "data grid"]
    },

    {
        type: "faq",
        group: "Data Grid",
        categorys: ["Trigger Grid Information", "Alarm Grid Information", "Event Grid Information", "Data Grid Information"],
        title: "How do i filter the grid data?",
        content: "At the top of a column, type in the text box to filter the column data to what contains your input. To clear,select the clear filter icon on the right of the inout box. To change how the text is filteres click the filter icon and select from the dropdown menu.",
        tags: ["export", "data grid"]
    },
    {
        type: "faq",
        group: "Navigation",
        categorys: ["Changelog"],
        title: "How do i see what features are currently under development and what are any known bugs?",
        content: "In the right of the main navigation bar, you will find the taskboard icon. Opening the taskboard will display all know issues aswell as the issue status. Archiv issues are also available to view here.",
        tags: ["bugs", "bug", "feature", "changelog", "issues"]
    },
    {
        type: "faq",
        group: "Navigation",
        categorys: ["Changelog"],
        title: "How do i find other cloud applications?",
        content: "In the right of the main navigation bar, you will find the link icon. The external navigation menu shows other Prima Power Azure cloud applications.",
        tags: ["bugs", "bug", "feature", "changelog", "issues"]
    },
    {
        type: "faq",
        group: "Navigation",
        categorys: ["nav"],
        title: "Can I hide the sidebar?",
        content: "You can toggle the sidebar to create more screen space by clicking on the icon next to the menu icon",
        tags: ["bugs", "bug", "feature", "changelog", "issues"]
    },
    {
        type: "faq",
        group: "Chart",
        categorys: ["Alarm Column Chart Information", "Trigger Chart Information", "Event Chart Information", "Alarms By Device Chart Information", "Chart Information", "Time Series Chart Information"],
        title: "How do i export the chart data?",
        content: "Clicking on the 3 dot icon in the top left corner of the chart opens the chart export menu.",
        tags: ["export", "chart"]
    },
    {
        type: "faq",
        group: "Chart",
        categorys: ["Alarm Column Chart Information", "Trigger Chart Information", "Event Chart Information", "Alarms By Device Chart Information", "Chart Information", "Time Series Chart Information"],
        title: "How do i zoom in on the chart?",
        content: "Use the mouse scroll to zoom in and zoom out of the chart. Click and drag the chart to pan the x axis.",
        tags: ["zoom", "pan", "chart"]
    },
    {
        type: "faq",
        group: "Chart",
        categorys: ["Chart Information", "Time Series Chart Information"],
        title: "How do i temporarily highlight a series/line on the chart?",
        content: "On the chart legend, hovering over a chart series label will highlight the series on the chart by dimming the other series aslong as you keep the mouse over the label.",
        tags: ["hover", "highlight", "legend", "chart"]
    },
    {
        type: "faq",
        group: "Chart",
        categorys: ["Chart Information", "Time Series Chart Information"],
        title: "How do i temporarily remove a series/line on the chart?",
        content: "On the chart legend, click on a chart series label to toggle showing the series on the chart.",
        tags: ["hover", "highlight", "legend", "chart"]
    },
    {
        type: "faq",
        group: "Timeline",
        categorys: ["Timeline Information"],
        title: "Why are some items on the timeline full text whilst others are an icon with a number next to it?",
        content: "The icons mean there is more than one item at that time. The number next to the icon shows how many items are in that cluster. Zoom in to break the cluster into smaller clusters and eventually a single item which is displayed as full text. Or you can click on the cluster icon to open a dialog window which lists the items of the cluster.",
        tags: ["cluster", "icons"]
    },
    {
        type: "faq",
        group: "Timeline",
        categorys: ["Timeline Information"],
        title: "What does 'group by' mean?",
        content: "The timeline can be viewed in two different ways which is determined by how the user wants to 'group' the data. Grouping the data by 'data type' means the data is grouped by what type of data it is for example all the alarms are one row regardless of which device the alarm came from. Grouping the data by device shows a seperate row for each device with its own alarm row etc and it's own machine states as background colors.",
        tags: ["groupBy"]
    },
    {
        type: "faq",
        group: "Timeline",
        categorys: ["Timeline Information"],
        title: "I don't want to see all the data at once on the timeline. How can I for example only see triggers?",
        content: "In the sidebar go to 'Timeline Data Types', select which data types you want to see and click update.",
        tags: ["groupBy"]
    },
    {
        type: "faq",
        group: "Timeline",
        categorys: ["Timeline Information"],
        title: "How is it possible to see on the timeline where a particular grid item is.",
        content: "Click in a data grid row will move a red arrow on the timeline to point to the timestamp of that row item.",
        tags: ["red arrow"]
    },
    {
        type: "faq",
        group: "Timeline",
        categorys: ["Timeline Information"],
        title: "How can i zoom in on the timeline",
        content: "Use the mouse scroll to zoom in and out of the timeline. Click and drag the timeline to pan",
        tags: ["zoom", "pan"]
    }, {
        type: "faq",
        group: "Timeline",
        categorys: ["Timeline Information"],
        title: "How can i zoom in on the timeline to the time of a grid item?",
        content: "Double click on a data grid row to zoom the timeline in on to that data grid item.",
        tags: ["zoom", "pan"]
    },
    {
        type: "faq",
        group: "Timeline",
        categorys: ["Timeline Information"],
        title: "What are the background colors?",
        content: "The background colors are the device state.Green=Running, Yellow=Idle, Red=failure. When viewing the timline in 'data type' mode, the machine states are of the main machine.",
        tags: ["colors", "states"]
    },
    {
        type: "faq",
        group: "Timeline",
        categorys: ["Timeline Information"],
        title: "How are the grids synced with the timeline?",
        content: "The data in the grids below the timeline is synced to show only the data that is between the target area (two blue lines) on the timeline. As the user scrolls and pans the timeline, the data in the grids will be updated,",
        tags: ["sync"]
    },
    {
        type: "definition",
        group: "Machine Times",
        categorys: ["Machine Times Chart Information"],
        title: "Running Duration",
        content: "Time spent in running state",
        tags: ["states", "colors", "green"]
    },
    {
        type: "definition",
        group: "Machine Times",
        categorys: ["Machine Times Chart Information"],
        title: "Idle Duration",
        content: "Time spent in idle state",
        tags: ["states", "colors", "yellow"]
    },
    {
        type: "definition",
        group: "Machine Times",
        categorys: ["Machine Times Chart Information"],
        title: "Idle after Running Duration",
        content: "Time spent in idle state occuring after a running state",
        tags: ["states", "colors", "yellow"]
    },
    {
        type: "definition",
        group: "Machine Times",
        categorys: ["Machine Times Chart Information"],
        title: "Idle after Failure Duration",
        content: "Time spent in idle state occuring after a failure state",
        tags: ["states", "colors", "orange"]
    },
    {
        type: "definition",
        group: "Machine Times",
        categorys: ["Machine Times Chart Information"],
        title: "Failure Duration",
        content: "Time spent in failure state",
        tags: ["states", "colors", "red"]
    },
    {
        type: "definition",
        group: "Machine Times",
        categorys: ["Machine Times Chart Information"],
        title: "Failure Timeout Duration",
        content: "If machine is in failure state and does not return to a running state the same day or after two hours , this is considered to be 'failure timeout'.",
        tags: ["states", "colors", "red"]
    },
    {
        type: "definition",
        group: "Machine Times",
        categorys: ["Machine Times Chart Information"],
        title: "Virtual Shift Duration",
        content: "Virtual Shift Duration is calculated time range from first running state of the day until the end of last running  or failure state (If last running state or failure state ends the next day then midnight is used as end of virtual shift). "
        , tags: ["states", "colors", "red"]
    },
    {
        type: "faq",
        group: "Machine Times",
        categorys: ["Machine Times Chart Information"],
        title: "Why are there extra state categories eg 'Idle after failure'?",
        content: "To enhance analysis on the machine states, extra categories have been added. Full definitions can be seen in the definitions tab. If you only want to view the 3 basic categories, go to 'Machine Times Filters' in the sidebar and turn off 'Machine Times Analysis'."
        , tags: ["states", "enriched", "categories", "failure timeout", "after running", "after failure"]
    },
    {
        type: "faq",
        group: "Machine Times",
        categorys: ["Machine Times Chart Information"],
        title: "How can there be 'no data' (the grey color on the chart)?",
        content: "Fleet management uses cloud data. Cloud data has to be uploaded from the customer machine to the cloud. Sometimes there can be for an example a network problem which means the data is not uploaded. Although there is failsafes in places, there is no guarantee the data will be uploaded. Then there is days eg weekends when there is no data to upload (the customer factory was closed). In these instances, the chart will display 'no data' (grey color on the chart). If you want to have the 'presumed' state (use the last known previous state so for example if the last state change on a Friday was Idle and then the state does not change again until Monday, we can presume the whole weekend was idle), you can turn off 'Active Times only' in the Machine Tiems filters panel of the sidebar."
        , tags: ["states", "enriched", "no data"]
    },
    {
        type: "dataTypes",
        group: "Machine Event Data",
        categorys: ["Alarms"],
        title: "Alarms",
        content: "Alarms are created on the machine for example when an error of some kind occurs or when there is a warning. There are two types of alarms: 'alarm' and 'message'. Only type 'alarm' is shown by default. Each alarm has a description and alarm number as well as extra information such as program name."
        , tags: ["alarms", "data type"]
    }
    ,
    {
        type: "dataTypes",
        group: "Machine Event Data",
        categorys: ["Triggers"],
        title: "Triggers",
        content: "Triggers are created on the machine by a triggered event for example a 'process interruption' or a 'camera record event' which is included as the description of the trigger. Triggers can contain more information for example 'processing mode', in fleet management this information is named 'trigger data'.  "
        , tags: ["triggers", "data type", "camera", "process interruption"]
    }
    ,
    {
        type: "dataTypes",
        group: "Machine Event Data",
        categorys: ["Manual Operations"],
        title: "Manual Oprations",
        content: "A manual operation is created by the machine when something is manually done on the machine for example a button is pressed or a door is opened.",
        tags: ["Manual Oprations", "data type"]
    }
    ,
    {
        type: "dataTypes",
        group: "Machine Event Data",
        categorys: ["Machine Times"],
        title: "Machine States",
        content: "Machine state data is created by the machine only when the device changes state. The 3 states are : running,idle and failure. Fleet management also gives the ability to categorise the idle and failure states to 'idle after running'', 'idle after failure', and 'failure timeout'",
        tags: ["Machone States", "data type"]
    },
    {
        type: "dataTypes",
        group: "Machine Measurement Data",
        categorys: ["MDC Data"],
        title: "MDC Data",
        content: "MDC Data is measurement data collected from the machine. There are two type, cumulative and none cumulative. Examples of cumulative include 'power on time' and 'total hits'. Example of none cumulative are certain temperature readings eg 'ram ballscrew temperature'. This data is collected at set intervals.",
        tags: ["MDC", "data type"]
    }
    ,
    {
        type: "dataTypes",
        group: "Machine Measurement Data",
        categorys: ["Cumulative_component_data,"],
        title: "Cumulative_component_data,",
        content: "Cumulative_component_data is shown in the Part wear out views. It is certain variable from MDC data structured in a format to show the parent component of the part and varaible values. The data from the full component can all be reset at the same time when a part is changed which means the lifetime of the component can be analyzed.",
        tags: ["Part wearout", "data type"]
    },
    {
        type: "dataTypes",
        group: "Machine Measurement Data",
        categorys: ["Scoped Data"],
        title: "Scoped Data",
        content: "Scoped data is a sample of measurements taken at triggered time. The data points each have a position value and a current value.",
        tags: ["Scoped", "data type"]
    },
    {
        type: "dataTypes",
        group: "PC Data",
        categorys: ["CPU Metrics"],
        title: "CPU Metrics",
        content: "The PC CPU usage is recorded at set intervals. It is available in bytes and percentage(used of available)",
        tags: ["PC", "CPU", "data type"]
    },
    {
        type: "dataTypes",
        group: "PC Data",
        categorys: ["Memory Metrics"],
        title: "Memory Metrics",
        content: "The PC Memory usage is recorded at set intervals. It is available in bytes and percentage(used of available)",
        tags: ["PC", "Memory", "data type"]
    },
    {
        type: "dataTypes",
        group: "PC Data",
        categorys: ["Top Processes"],
        title: "Top Processes",
        content: "The PC CPU usage is recorded at set intervals for the top then proccesses at the time of the interval. It is available in bytes and percentage(used of available)",
        tags: ["PC", "Top Processes", "data type"]
    }
    ,
    {
        type: "dataTypes",
        group: "PC Data",
        categorys: ["Windows Event Logs"],
        title: "Windows Event Logs",
        content: "Windows Event Logs collected from the PC",
        tags: ["PC", "Windows Event Logs", "data type"]
    }
    ,
    {
        type: "dataTypes",
        group: "PC Data",
        categorys: ["S.M.A.R.T"],
        title: "S.M.A.R.T",
        content: "Self-Monitoring, Analysis, and Reporting Technology (S.M.A.R.T. or SMART) is a monitoring system included in computer hard disk drives (HDDs) and solid-state drives (SSDs).[3] Its primary function is to detect and report various indicators of drive reliability, or how long a drive can function while anticipating imminent hardware failures. Data example is hard disc life.",
        tags: ["PC", "S.M.A.R.T", "data type"]
    },
    {
        type: "dataTypes",
        group: "PC Data",
        categorys: ["Switch Data"],
        title: "Switch Data",
        content: "Switch Data collects the values, successful packets and failed packets for each port of the switch at set intervals.",
        tags: ["PC", "Switch", "packers", "data type"]
    },
    {
        type: "faq",
        group: "General Filters",
        categorys: ["Selected General Filters Information"],
        title: "Where can i see the selected customer /machine?",
        content: "The Selected General Filters Panel gives a clear view of the selected general filters from the side bar.",
        tags: ["filters", "selection", "assembly", "customer", "devices", "date range"]
    }

    ,
    {
        type: "definition",
        group: "Time Series Dashboard",
        categorys: ["Time Series Chart", "Time Series Grid"],
        title: "Initial Value",
        content: "The first value recorded in the database (earliest timestamp) "
        , tags: ["intitial value"]
    }
    ,
    {
        type: "definition",
        group: "Time Series Dashboard",
        categorys: ["Time Series Chart", "Time Series Grid"],
        title: "Range Sum",
        content: "The sum of values within the selected date range for selected header and customer device. "
        , tags: ["range"]
    }
    ,
    {
        type: "definition",
        group: "Time Series Dashboard",
        categorys: ["Time Series Chart", "Time Series Grid"],
        title: "Range Max",
        content: "The highest value within the selected date range for selected header and customer device."
        , tags: ["range"]
    }
    ,
    {
        type: "definition",
        group: "Time Series Dashboard",
        categorys: ["Time Series Chart", "Time Series Grid"],
        title: "Range Min",
        content: "The lowest value within the selected date range for selected header and customer device."
        , tags: ["range"]
    }
    ,
    {
        type: "definition",
        group: "Time Series Dashboard",
        categorys: ["Time Series Chart", "Time Series Grid"],
        title: "Range Average",
        content: "The average of all values within the selected date range for selected header and customer device."
        , tags: ["range"]
    }
    ,
    {
        type: "definition",
        group: "Time Series Dashboard",
        categorys: ["Time Series Chart", "Time Series Grid"],
        title: "All time Sum",
        content: "The sum of values in the database for selected header and customer device."
        , tags: ["range"]
    }
    ,
    {
        type: "definition",
        group: "Time Series Dashboard",
        categorys: ["Alarm Chart"],
        title: "Alarm Frequency",
        content: "Total number of interrupting alarms. Interrupting alarms are determined as alarms occurring at the time of a machine changing into failure state."
        , tags: ["range"]
    }
    ,
    {
        type: "definition",
        group: "Time Series Dashboard",
        categorys: ["Process interrupts"],
        title: "Interrupts/running hour",
        content: "Total number process interruption triggers devided by running duration hours."
        , tags: ["process interruption"]
    }
];


export default info;




